import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';

import Btn from './components/UI/btn';
import Input from './components/UI/input';
import Wait from './components/UI/wait';

Vue.use(VueCookies);
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

Vue.component('Btn', Btn);
Vue.component('Input', Input);
Vue.component('Wait', Wait);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');